import { tuple } from '../../_util/type';

export const PlaceMent = tuple('top', 'bottom');
